import { render, staticRenderFns } from "./ExamTime.vue?vue&type=template&id=5f2d4a06"
import script from "./ExamTime.vue?vue&type=script&lang=js"
export * from "./ExamTime.vue?vue&type=script&lang=js"
import style0 from "./ExamTime.vue?vue&type=style&index=0&id=5f2d4a06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports